//# sourceMappingURL=/s/files/1/2574/3030/t/24/assets/custom.js.map?v=1600074588
const urlPath = window.location.pathname;
const pathSegments = urlPath.split('/');
const product_handle = pathSegments[pathSegments.length - 1]; 
$(document).ready(function() {
  $(function(){

    function slickOnResize(){
        $(".AnnouncementBar__Wrapper .flex-row").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed:6000,
        arrows: false,
        dots: false,
        mobileFirst: true,
        responsive: [
                {
            breakpoint: 767,
            settings : {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
          },
          {
            breakpoint: 768,
            settings: 'unslick'
          }
        ]
        });
    }

    slickOnResize();

    $(window).resize(function(){
        var $window_width = $(window).width();
        if ($window_width < 768) {
            $(".AnnouncementBar__Wrapper .flex-row").slick("resize");
        }
    });

});

 

  // Add To Cart Button Jquery Start
  function open_sidebar(){

    $.ajax({
      url: "/",
      type: "GET",
      success: function (response) { 
         var required_contentblock_html = $(response).find("form.Cart.Drawer__Content").html(); 
         $("form.Cart.Drawer__Content").html(required_contentblock_html); 
        $('body').addClass('cdk_cart_open'); 
        $('.PageOverlay').addClass('is-visible');
        $('#sidebar-cart').attr('aria-hidden', 'false').attr('tabindex', '-1');
        $('html').addClass('no-scroll');
        $('.LoadingBar').removeClass('is-visible').css('width', '0%');
      },
    }) 
  }
  
function ajaxAddToCart(dynamicData, thisbtn) {   
  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: { items: dynamicData }, 
    dataType: "json",
    success: function(data){ 
      thisbtn.text('Add To Cart');
      $('.LoadingBar').addClass('is-visible').css('width', '90%');
      open_sidebar();
    }, 
     error: function(jqXHR) {
      if (jqXHR.status == 400 || jqXHR.status == 422) {
        let errorMsg = jqXHR.responseJSON.message || jqXHR.responseJSON.description;

        // If the error message indicates sold out
        if (errorMsg && errorMsg.toLowerCase().includes("sold out")) {
          thisbtn.text('Sold Out');
        } else {
          thisbtn.text('Add To Cart');
        }

        // alert(errorMsg);
      } else {
        thisbtn.text('Add To Cart');
      }
    }
  });
}

$(document).on('click', '.cdk_Product__AddToCart', function () {
  var thisbtn = $(this);
  var thisId = thisbtn.attr('data-var-id'); 
  thisbtn.text('Please wait...');

  var items = [{ quantity: 1, id: thisId }]; 
  ajaxAddToCart(items, thisbtn);
});


  $(document).on('click', '.cdk_cart_open .PageOverlay.is-visible, .cdk_cart_open .Drawer__Close ', function () {
    $('body').removeClass('cdk_cart_open'); 
    $('.PageOverlay').removeClass('is-visible');
    $('#sidebar-cart').attr('aria-hidden', 'true').attr('tabindex', '');
    $('html').removeClass('no-scroll');
  });
 
  $(document).on('click', '.cdk_heading_outer .cdk_heading', function () {
  var thisId = $(this).attr('data-id'); 
  $('.cdk_heading_outer .cdk_heading').removeClass('active');
  $(this).addClass('active');
  $('.cdk_tab_main').hide().removeClass('cdk_enabled_rv');
  $('.cdk_tab_main[data-id="'+thisId+'"]').show();
    setTimeout(function () {  
      var flkty = new Flickity('#shopify-section-product-recommendations .ProductList--carousel'); 
      flkty.resize();
    },1500)
  
  });
 
  
  $(document).on('change', 'select.bb_data_selling_plans', function () {

  var thisSellingId = $(this).val();
    $('.cdk_subsc__AddToCart').attr('data-selling-plan-id', thisSellingId);
  });
  
  $(document).on('click' ,'.cdk_subsc__AddToCart',function(){
  $(this).text('Please wait...'); 
  var items = [];    
  var quantity = 1;
  var variantId = $(this).attr('data-var-id');
  var selling_plan = $(this).attr('data-selling-plan-id'); 
  items.push({ "quantity": quantity,  "id": variantId, "selling_plan": selling_plan}); 
    
  ajaxAddToCart(items) ;
   
});
 
 $(document).on('click', 'a.cdk_link_anchor', function (event) {
   event.preventDefault();
   var url = $(this).attr('href'); 
   if (url == '#'){
     
   }  
   else{
   window.location.href = url;  
   }
   
 })

/* cdk video code start */
  $(document).on('click', '.cdk_btn_main_play', function () {
    var $mainThis  = $(this).parents('.cdk_video__Container');
    var $thisVideo = $mainThis.find('video');
    var $thisPlay  = $mainThis.find('.cdk_btn_play');
    var $thisPause = $mainThis.find('.cdk_btn_pause');
    
    if ($($thisVideo).get(0).paused) {
    $($thisVideo).trigger('play'); 
      $($mainThis).removeClass('video_playing');
    } else {
    $($thisVideo).trigger('pause'); 
      $($mainThis).addClass('video_playing');
    }
    
  });
  // var videoElement = document.getElementById("cdk_video_container");
  // var aud = document.getElementById("cdk_video");
  // aud.onended = function() {
  //    videoElement.classList.add("video_playing");
  // };
  /* cdk video code End */

 
  $(document).on('click', '.cdk--custom_subscription_options .subscription_pan_item .sub_option', function () {
    var thisAttr = $(this).attr('data-type');
    var normal_price = $('.cdk_select_options_default').find('option[selected="selected"]').attr('data-var-price');
    var normal_comp_price = $('.cdk_select_options_default').find('option[selected="selected"]').attr('data-var-compare-price');
    var sub_price = $('.cdk_select_options_default').find('option[selected="selected"]').attr('data-price-sp');
    var sub_comp_price = $('.cdk_select_options_default').find('option[selected="selected"]').attr('data-compare-price-sp');
    var sub_afpPrice = $('.cdk_select_options_default').find('option[selected="selected"]').attr('data-price-sp_af');
    var afpPrice = $('.cdk_select_options_default').find('option[selected="selected"]').attr('data-price_af');
    var selected_variant =  $('.cdk_select_options_default').find('option[selected="selected"]').attr('data-variant-main');
        
    $('.product_swatches_Quantity .regilar_price_sub, .product_swatches_Quantity .regilar_price_ns').hide();
    $('.cdk--custom_subscription_options .subscription_pan_item .sub_option').removeClass('active');
    $(this).addClass('active');

    if( thisAttr == 'subscription'){
      $('.cdk--custom_subscription_box').show();
      $('.Product__Info .ProductMeta__PriceList .ProductMeta__Price.Price--highlight').html(sub_price);
      $('.Product__Info .ProductMeta__PriceList .ProductMeta__Price.Price--compareAt').html(normal_comp_price);
      $('.afterpay_location .cp_ap_text .af_preice').html(sub_afpPrice);
      $('.cdk_Product_subsc__AddToCart').show();
      $('.shopify-payment-button').hide();
      $('.product_swatches_Quantity .regilar_price_sub[data-option-1="1"]').show();
    }else{
      $('.cdk--custom_subscription_box').hide();
       $('.Product__Info .ProductMeta__PriceList .ProductMeta__Price.Price--highlight').html(normal_price);
       $('.Product__Info .ProductMeta__PriceList .ProductMeta__Price.Price--compareAt').html(normal_comp_price);
       $('.afterpay_location .cp_ap_text .af_preice').html(afpPrice);
       $('.cdk_Product_subsc__AddToCart').hide();
       $('.shopify-payment-button').show();
       $('.product_swatches_Quantity .regilar_price_ns[data-option-1="1"]').show();
    }
    
  })
 
  $(document).on('click', '.ProductForm__Variants .HorizontalList__Item label', function () {
  setTimeout(function () {
    var thisAttr = $('.cdk--custom_subscription_options .subscription_pan_item .sub_option.active').attr('data-type');
    var normal_price = $('.cdk_select_options_default').find('option[selected="selected"]').attr('data-var-price');
    var normal_comp_price = $('.cdk_select_options_default').find('option[selected="selected"]').attr('data-var-compare-price');
    var sub_price = $('.cdk_select_options_default').find('option[selected="selected"]').attr('data-price-sp');
    var sub_comp_price = $('.cdk_select_options_default').find('option[selected="selected"]').attr('data-compare-price-sp');
    var sub_afpPrice = $('.cdk_select_options_default').find('option[selected="selected"]').attr('data-price-sp_af');
    var afpPrice = $('.cdk_select_options_default').find('option[selected="selected"]').attr('data-price_af');
    var selected_variant =  $('.cdk_select_options_default').find('option[selected="selected"]').attr('data-variant-main');
    var OptionLeng = $('#cdk_prod_SIngle_option').length;
    if(OptionLeng == 1){
      
    }else{
     $('.product_swatches_Quantity .regilar_price_sub, .product_swatches_Quantity .regilar_price_ns').hide(); 
    }
     
    
      if( thisAttr == 'subscription'){ 
          $('.Product__Info .ProductMeta__PriceList .ProductMeta__Price.Price--highlight').html(sub_price);
          $('.Product__Info .ProductMeta__PriceList .ProductMeta__Price.Price--compareAt').html(normal_comp_price); 
          $('.afterpay_location .cp_ap_text .af_preice').html(sub_afpPrice);
          $('.cdk_Product_subsc__AddToCart').show();
          $('.shopify-payment-button').hide();
          $('.product_swatches_Quantity .regilar_price_sub[data-option-1="'+selected_variant+'"]').show();
      }else{ 
           $('.Product__Info .ProductMeta__PriceList .ProductMeta__Price.Price--highlight').html(normal_price);
           $('.Product__Info .ProductMeta__PriceList .ProductMeta__Price.Price--compareAt').html(normal_comp_price);
           $('.afterpay_location .cp_ap_text .af_preice').html(afpPrice); 
           $('.cdk_Product_subsc__AddToCart').hide();
           $('.shopify-payment-button').show();
           $('.product_swatches_Quantity .regilar_price_ns[data-option-1="'+selected_variant+'"]').show();
      }     
     },500)
 
  });
 
  $(document).on('click', '.cdk_Product_subsc__AddToCart', function () {
    var items = [];  
    var selling_plan = $('.cdk--custom_subscription_box .product_subscription_Blocks .cdk_prod_selling_palns').val();
    var variantId = $('.cdk_select_options_default').find('option[selected="selected"]').attr('value');
    var quantity = $('.ProductForm__QuantitySelector input.QuantitySelector__CurrentQuantity').val();
    items.push({ "quantity": quantity,  "id": variantId, "selling_plan": selling_plan}); 
    
    ajaxAddToCart(items) ;
    $('.LoadingBar').addClass('is-visible').css('width', '50%');
  })


  var selected_variant =  $('.cdk_select_options_default').find('option[selected="selected"]').attr('data-variant-main');
  $('.product_swatches_Quantity .regilar_price_ns[data-option-1="'+selected_variant+'"]').show();


   $(document).on('click', 'li.HorizontalList__Item.var-quantity', function () {
     var title = $('.quantity_unit',this).text();
     $('.variant-title__item').text(title);
     var vtitle = title.replace('-Pack','');
     $('.sub-price').hide();
     $('.sub-price').each(function(){
        var type = $(this).attr('data-title');    
        if(type == vtitle)
        {
          $(this).show();
        }
        
      });
   });

  var cvar = $('.current-variant').text();
  $('.sub-price').hide();

  $('.sub-price').each(function(){

    var type = $(this).attr('data-title');

    if(type == cvar)
    {
      $(this).show();
    }
    
  });
  
  // --------- sukhcode for update percentvalue start ----------- \\
        $('.ProductForm__Option .SizeSwatchList.HorizontalList li.HorizontalList__Item.var-size').each(function(){
        $(this).on('click', function(){
          var mainvarselect = $('.ProductForm__Option .SizeSwatchList.HorizontalList li.HorizontalList__Item.var-size');
            mainvarselect.removeClass('var_active');
            $(this).addClass('var_active');
        });
    });
      $('.ProductForm__Option .SizeSwatchList.HorizontalList li.HorizontalList__Item.var-quantity').each(function(){
        $(this).on('click', function(){
          var mainvarselect = $('.ProductForm__Option .SizeSwatchList.HorizontalList li.HorizontalList__Item.var-quantity');
            mainvarselect.removeClass('var_active');
            $(this).addClass('var_active');
        });
    });
    // $('.ProductForm__Option .product_swatches_Quantity li.HorizontalList__Item.var-quantity').each(function(){
    //     $(this).on('click', function(){
    //       var mainvarselect = $('.ProductForm__Option .product_swatches_Quantity li.HorizontalList__Item.var-quantity');
    //         mainvarselect.removeClass('var_active');
    //         $(this).addClass('var_active');
    //         var savePercent = $(this).find('.regular_price:visible .discount_percentage').data('percent');
    //         $('.custom-discount').text(savePercent);
    //         // alert(savePercent);
    //     });
    // });
    $('.cdk--custom_subscription_options .subscription_pan_item').on('click', function() {
      setTimeout(function() {
        $('.product_swatches_Quantity li.HorizontalList__Item.var-quantity.var_active').trigger('click');
        }, 100);
    });
  $('.ProductForm__Variants .HorizontalList__Item input:checked').each(function() {
    $(this).trigger('click');
  });
 // --------- sukhcode for update percentvalue end ----------- \\
});



// ====----= UTK D =====//
var option1;
var option2;
var image_variant;
$(document).ready(function() {
    $(".ProductForm__Variants .HorizontalList__Item input:checked+label").trigger("click");
});

function updateTitleTotal() {
var var_title_total = "";
if (option1 && option2) {
    var_title_total = option1 + " / " + option2;
} else if (option1) {
    var_title_total = option1;
} else if (option2) {
    var_title_total = option2;
}

  
  //  $('.cstm-dropdown').val(var_title_total).change();

    var matched = false;
    $("#select_id_cstm_drpdwn option").each(function() {
        var optionText = $(this).text();
        if (optionText === var_title_total.trim()) {
          var selectedText = $(this).attr("data-disc-off");
          var image_variant = $(this).attr("data-image-url");
         $(".slick-track .ctm_pro_img_wrp.slick-current.slick-active").find('img').attr("src", image_variant);
          $(".slick-track .ctm_pro_img_wrp.slick-current.slick-active").find('a').attr("href", image_variant);
          if (selectedText === "0") {
              $(".new_position_percent_off").css("display", "none");
          } else {
              $(".new_position_percent_off").css("display", "block");
              var existingDiscount = $(".new_position_percent_off .custom-discount");
              if (existingDiscount.length > 0) {
                  existingDiscount.text(selectedText + "% Off");
              } else {
                  var discountText = selectedText + "% Off";
                  var discountHTML = '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4 custom-discount">' + discountText + '</span>';
                  $(".new_position_percent_off").append(discountHTML);
              }
          }
         $(".new_position_percent_off .custom-discount").text(selectedText+"% Off");
            $(this).prop("selected", true);
            $("#select_id_cstm_drpdwn").trigger("change");
            matched = true;
            return false;
        }
    });
}

$(".ProductForm__Option.opt_1 label.SizeSwatch").on("click", function(){
    option1 = $(this).text().trim();
   option2 = $(this).find(".quantity_unit .count_val").text().trim();
    updateTitleTotal();
});

$(".ProductForm__Option.opt_2 label.SizeSwatch").on("click", function(){
    option2 = $(this).find(".quantity_unit .count_val").text().trim();
    updateTitleTotal();
});

$("#select_id_cstm_drpdwn").on("change", function(){
    var selectedText = $(this).find("option:selected").attr("data-disc-off");
    $(".new_position_percent_off .custom-discount").text(selectedText+"% Off");
});

// ==== Code For changing image ==== //
$("li.HorizontalList__Item.var-size").on("click", function() {
    setTimeout(function() {
        // Ensure the element exists before triggering the click event
        var targetElement = $("li.HorizontalList__Item.var-quantity.var_active .SizeSwatch");

        if (targetElement.length > 0) {
            targetElement.trigger("click");
        }
    }, 1000);
});






setTimeout(function () { 
  $('.product_swatches_Quantity .HorizontalList__Item.var-quantity label').each(function(){
         $(this).find('.regilar_price_ns:first').show(); 
  });
},1500);


$(document).ready(function() {
    // === Single wala ==
    $('li.HorizontalList__Item').on('click', function() {
        var $activeSizeItem = $('.HorizontalList__Item.var-size.var_active');
        if ($activeSizeItem.length === 0) {
            return;
        }
        var $selectsize = $activeSizeItem.find('input').val();
        if (!$selectsize) {
            return;
        }
       if ($('#one-time-purchase').is(':checked')) {
        $('.HorizontalList__Item.var-quantity').each(function() {
            var $quantityItem = $(this);
            var $selectedquat = $quantityItem.find('label .regilar_price_ns').data('option-1');
            setTimeout(function() {
                if ($selectedquat == $selectsize) {
                    var $elementToShow = $quantityItem.find('.regilar_price_ns[data-option-1="' + $selectsize + '"]');
                    if ($elementToShow.length) {
                        $elementToShow.show();
                    } else {
                    }
                } else {
                    var $elementToHide = $quantityItem.find('.regilar_price_ns[data-option-1="' + $selectsize + '"]');
                    if ($elementToHide.length) {
                        $elementToHide.show();
                    } else {
                    }
                }
            }, 1000);
        });
       }else{
           $('.HorizontalList__Item.var-quantity').each(function() {
            var $quantityItem = $(this);
            var $selectedquat = $quantityItem.find('label .regilar_price_sub').data('option-1');
            setTimeout(function() {
                if ($selectedquat == $selectsize) {
                var $elementToShow = $quantityItem.find('.regilar_price_sub[data-option-1="' + $selectsize + '"]');
                var discount_text = $(".HorizontalList__Item input:checked+label").find('span.discount_percentage:visible').attr("data-percent");
                
                if (discount_text) {
                    $(".custom-discount").text(discount_text);
                }

                    if ($elementToShow.length) {
                        $elementToShow.show();
                    } else {
                    }
                } else {
                    var $elementToHide = $quantityItem.find('.regilar_price_sub[data-option-1="' + $selectsize + '"]');
                    if ($elementToHide.length) {
                        $elementToHide.show();
                    } else {
                    }
                }
            }, 1000);
        });
       }
    });
});



$(document).ready(function(){
  $("label.SizeSwatch").on("click", function(){
    setTimeout(function(){
      var discount_top_text = $(".var-quantity.var_active .SizeSwatch .regular_price:visible .discount_percentage").data('percent');
      if (discount_top_text) {
        $(".custom-discount").text(discount_top_text);
      }
    }, 1000);
  });
});


    $('.collection_anchor').click(function(){
        var data = $(this).attr('href')
       window.location.href= data
    })

// change the slider image on change
$(document).ready(function(){
  setTimeout(function() {
  var priceText_nav = $('.Price--highlight').text().trim();
    $('.ProductForm__AddToCart span[data-money-convertible], .yp__a2cart__price').text(priceText_nav);
  console.log(priceText_nav);
  }, 1000);
  
    $(".HorizontalList__Item.var-quantity").on("click", function() {
        var Image_our = $(this).find(".regular_price").data('var-ak-image');
      $(".slick-track .ctm_pro_img_wrp.slick-current.slick-active").find('img').attr("src", Image_our);
      $(".slick-track .ctm_pro_img_wrp.slick-current.slick-active").find('a').attr("href", Image_our);
    });
  $(".cstm-related-products").click(function(){
    alert("kjnk");
    
  })
});



// Get the handle from the current page’s URL path
if (product_handle === "black-oud-beard-oil") {
$('input[name="subscription_type"]').on('change', function () {
    const selectedValue = $(this).attr('data-type');
    if(selectedValue == 'one-time'){
        $('input.nav-selling_plan').attr('value','');

        var priceText = $('.Price--highlight').text().trim();
        // $('.ProductForm__AddToCart span[data-money-convertible], .yp__a2cart__price').text(priceText);
    }
    else if(selectedValue == 'subscription'){
        let cdk_prod_selling_palns_val = $('.cdk--custom_subscription_box select.cdk_prod_selling_palns').val();
        $('input.nav-selling_plan').attr('value',cdk_prod_selling_palns_val);

        var priceText = $('.Price--highlight').text().trim();
        // $('.ProductForm__AddToCart span[data-money-convertible], .yp__a2cart__price').text(priceText);
    }
});
}
$('.cdk--custom_subscription_box select.cdk_prod_selling_palns').on('change', function () {
    const selectedValue = $(this).val();
    $('input.nav-selling_plan').attr('value',selectedValue);
});








